import { StartClient } from "@tanstack/react-start/client"
import { StrictMode } from "react"
import { hydrateRoot } from "react-dom/client"
import { readLanguageFromHtmlLangAttribute } from "./i18n/i18n"
import { loadCatalog } from "./i18n/loadMessages"

// Sentry is initialized in router.tsx with tanstackRouterBrowserTracingIntegration
// after the router is created, so we have access to the router instance for proper tracing

// Initialize i18n on client side before hydration
const initializeI18n = async () => {
  const language = readLanguageFromHtmlLangAttribute()
  await loadCatalog(language)
}

// Wait for i18n to be initialized before hydrating
void initializeI18n().then(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <StartClient />
    </StrictMode>,
  )
})
